import styled from "styled-components";

const UsersGridTableColumn = styled.td`
    width: ${({ width }) => width}%;
    padding: 0.6rem !important;
    vertical-align: middle;
`;

export default UsersGridTableColumn;